module.exports = __webpack_public_path__ + "static/media/992644.74910caa.png";